import React, { useCallback } from 'react';
import { toast } from 'react-toastify';
import { SubmitHandler } from 'react-hook-form';
import {
  useGetRoleByIdSuspense,
  useUpdateRole,
} from '@area-restrita/api-client/endpoints/roles/roles.gen';
import { UpdateRoleBodyDto } from '@area-restrita/api-client/model/updateRoleBodyDto';

import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';

import RoleForm from '../../components/RoleForm';

interface RoleDetailsProps {
  id: number;
}

const RoleDetails: React.FC<RoleDetailsProps> = ({ id }) => {
  const { data: role } = useGetRoleByIdSuspense(id);

  const updateRoleMutation = useUpdateRole();

  const handleSubmit = useCallback<SubmitHandler<UpdateRoleBodyDto>>(
    (data) =>
      updateRoleMutation.mutateAsync(
        { id, data },
        {
          onSuccess: () => {
            toast.success('Função atualizada com sucesso!');
          },
          onError: () => {
            toast.error('Erro ao atualizar função');
          },
        },
      ),
    [id, updateRoleMutation],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Detalhes da Função - {role.name}</CardTitle>
        <CardDescription>
          Aqui você pode visualizar e gerenciar os detalhes da função
          selecionada.
        </CardDescription>
      </CardHeader>
      <RoleForm
        defaultValues={{
          name: role.name,
          description: role.description,
          rules: role.rules,
        }}
        onSubmit={handleSubmit}
      />
    </Card>
  );
};

export default RoleDetails;
